<template>
<body id="body">
  <the-app-header></the-app-header>
  <slot></slot>
  <the-app-footer></the-app-footer>
</body>
</template>

<script>
import Header from '../components/shared/GuestHeader'
import Footer from '../components/shared/GuestFooter'
export default {
  components: {
    TheAppHeader: Header,
    TheAppFooter: Footer
  },
  created () {
    // this.$loadScript('../../static/static-js/jquery-2.2.4.min.js')
    // this.$loadScript('../../static/static-js/bootstrap.min.js')
    // this.$loadScript('../../static/static-js/owl.carousel.min.js')
    // this.$loadScript('../../static/static-js/jquery.countdown.min.js')
    // this.$loadScript('../../static/static-js/waypoints.min.js')
    // this.$loadScript('../../static/static-js/jquery.magnific-popup.min.js')
    // this.$loadScript('../../static/static-js/plugins.js')
    // // this.$loadScript('../../static/static-js/wow.min.js')
    // this.$loadScript('../../static/rev-slider/js/jquery.themepunch.tools.min.js')
    // this.$loadScript('../../static/rev-slider/js/jquery.themepunch.revolution.min.js')
    // this.$loadScript('../../static/rev-slider/js/revolution.extension.actions.min.js')
    // this.$loadScript('../../static/rev-slider/js/revolution.extension.layeranimation.min.js')
    // this.$loadScript('../../static/rev-slider/js/revolution.extension.navigation.min.js')
    // this.$loadScript('../../static/rev-slider/js/revolution.extension.parallax.min.js')
    // this.$loadScript('../../static/rev-slider/js/revolution.extension.slideanims.min.js')
    // this.$loadScript('../../static/rev-slider/js/revolution.extension.video.min.js')
    // new WOW().init()
    // setTimeout(() => {
    //   let script = document.createElement('script')
    //   script.setAttribute('src', '../../static/static-js/script.js')
    //   document.head.appendChild(script)
    // }, 1000)
    // this.$loadScript('../../static/static-js/script.js')
  }
}
</script>

<style lang="scss">
// @import "../../static/static-css/bootstrap.min.css";
// @import "../../static/static-css/elegant-font.css";
// @import "../../static/static-css/owl.carousel.css";
// @import "../../static/static-css/video.min.css";
// @import "../../static/static-css/animate.css";
// @import "../../static/rev-slider/css/settings.css";
// @import "../../static/rev-slider/css/layers.css";
// @import "../../static/rev-slider/css/navigation.css";
// @import "../../static/static-css/style.css";
// @import "../../static/static-css/responsive.css";
</style>



// WEBPACK FOOTER //
// src/layouts/GuestLayout.vue